import { render } from "./Header.vue?vue&type=template&id=d564b4bc&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=d564b4bc&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2335455550/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d564b4bc"]])

export default __exports__